<template>
  <div class="statistics-container">
    <div>
      <!-- 库存预警 -->
      <el-card class="inventory-warning-card" v-if="form.warningNumber > 0">
        <div class="inventory-warning">
          <span class="warning-label">库存预警数</span>
          <span class="warning-count">{{ form.warningNumber }}款</span>
          <span class="warning-icon"><i class="el-icon-warning-outline"></i></span>
          <span class="warning-text">需及时补货</span>
        </div>
      </el-card>

      <!-- 顶部统计卡片 -->
      <el-row :gutter="20" class="stats-cards">
        <el-col :span="8">
          <el-card shadow="hover" class="stats-card">
            <div class="card-title">待发货订单</div>
            <div class="card-content">
              <div class="main-value">{{ form.deliverGoods }}</div>
              <!-- <div class="trend up">
                <i class="el-icon-caret-top"></i>
                {{form.deliverGoodsPercent}}% 同比
              </div> -->
            </div>
            <div class="card-icon blue">
              <i class="el-icon-truck"></i>
            </div>
          </el-card>
        </el-col>

        <!-- <el-col :span="6">
          <el-card shadow="hover" class="stats-card">
            <div class="card-title">待处理退款</div>
            <div class="card-content">
              <div class="main-value">4</div>
              <div class="trend down">
                <i class="el-icon-caret-bottom"></i>
                8.5% 同比
              </div>
            </div>
            <div class="card-icon red">
              <i class="el-icon-refresh"></i>
            </div>
          </el-card>
        </el-col> -->

        <el-col :span="8">
          <el-card shadow="hover" class="stats-card">
            <div class="card-title">本月订单总量</div>
            <div class="card-content">
              <div class="main-value">{{ form.totalOrder }}</div>
              <div v-if="form.totalOrderPercentIsup == 0" class="trend">
                {{ form.totalOrderPercent }}% <span style="color: black;">上月同期</span>
              </div>
              <div v-else-if="form.totalOrderPercentIsup == 1" class="trend up">
                <i class="el-icon-caret-top"></i>
                {{ form.totalOrderPercent }}% <span style="color: black;">上月同期</span>
              </div>
              <div v-else class="trend down">
                <i class="el-icon-caret-down"></i>
                {{ form.totalOrderPercent }}% <span style="color: black;">上月同期</span>
              </div>
            </div>
            <div class="card-icon green">
              <i class="el-icon-shopping-cart-full"></i>
            </div>
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card shadow="hover" class="stats-card">
            <div class="card-title">本月销售总额</div>
            <div class="card-content">
              <div class="main-value">¥{{ form.totalSold }}</div>
              <div v-if="form.totalSoldPercentIsup == 0" class="trend">

                {{ form.totalSoldPercent }}% <span style="color: black;">上月同期</span>
              </div>
              <div v-else-if="form.totalSoldPercentIsup == 1" class="trend up">
                <i class="el-icon-top"></i>
                {{ form.totalSoldPercent }}% <span style="color: black;">上月同期</span>
              </div>
              <div v-else class="trend down">
                <i class="el-icon-bottom"></i>
                {{ form.totalSoldPercent }}% <span style="color: black;">上月同期</span>
              </div>
            </div>
            <div class="card-icon purple">
              <i class="el-icon-money"></i>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 店铺运营指标 -->
      <div class="indicator-title">店铺运营指标</div>

      <el-row :gutter="20" class="indicator-cards">
        <el-col :span="8">
          <el-card shadow="hover" class="indicator-card">
            <div class="indicator-name">商品上架数</div>
            <div class="indicator-value">{{ form.goodsNumber }}</div>
            <div class="indicator-desc">
              <i class="el-icon-goods"></i> 在售商品总数
            </div>
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card shadow="hover" class="indicator-card">
            <div class="indicator-name">平均发货时间</div>
            <div class="indicator-value">{{ form.sendTime }}h</div>
            <div class="indicator-desc"></div>
          </el-card>
        </el-col>

        <!-- <el-col :span="6">
          <el-card shadow="hover" class="indicator-card">
            <div class="indicator-name">退款率</div>
            <div class="indicator-value">2.1%</div>
            <div class="indicator-desc down">比上月下降0.4%</div>
          </el-card>
        </el-col> -->

        <el-col :span="8">
          <el-card shadow="hover" class="indicator-card">
            <div class="indicator-name">客单价</div>
            <div class="indicator-value">¥{{ form.perCustomer }}</div>
            <div v-if="form.perCustomerPercentIsup == 0" class="indicator-desc">
              <span style="color: black;">{{ form.perCustomerPercent }}%上月同期</span>
            </div>

            <div v-else-if="form.perCustomerPercentIsup == 1" class="indicator-desc up">
              <i class="el-icon-top"></i>
              {{ form.perCustomerPercent }}%
              <span style="color: black;">上月同期</span>
            </div>
            <div v-else class="indicator-desc down">
              <i class="el-icon-bottom"></i>%
              <span style="color: black;">{{ form.perCustomerPercent }}上月同期</span>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>


</template>

<script>
// import { mapGetters } from 'vuex'
import { dataDisplay } from '@/api/sjzx'
export default {
  name: 'statistics',
  data() {
    return {
      form: {
        warningNumber: '--',//预警数量
        deliverGoods: '--',//待发货数量
        goodsNumber: '--',//商品上架数
        perCustomer: '--',//客单价
        perCustomerPercent: '--',//客单价上月同期
        sendTime: '--',//平均发货时间
        totalOrder: '--',//本月订单总量
        totalOrderPercent: '--', //订单总量上月同期
        totalSold: '--',//本月销售总额
        totalSoldPercent: '--',//销售总额上月同期,
        perCustomerPercentIsup: true,
        totalOrderPercentIsup: true,
        totalSoldPercentIsup: true,
        IsHave: false,//主体类型
      }

    }
  },
  computed: {
    // ...mapGetters([
    //   "identityObj",
    // ]),
  },
  created() {
    // this.getIsHave()
  },
  mounted() {
    this.getDataDisplay()
  },
  methods: {
    //判断是草稿还是保存
    // getIsHave() {
    //   //0保存，1草稿
    //   // let identityObj = localStorage.getItem("identityObj") || []
    //   // 从本地存储加载草稿
    //   const draft = localStorage.getItem('identityObj')
    //   if (draft) {
    //     try {
    //       const identityObj = JSON.parse(draft)
    //       if (identityObj) {
    //         // let obj = JSON.parse(identityObj)
    //         this.IsHaveobj = identityObj.content.shop.draftFlag == null ? false : identityObj.content.shop.draftFlag == 0 ? true : false
    //         console.log(this.IsHave,'查看this.IsHave')
    //       }
    //     } catch (e) {
    //       console.error('解析草稿数据失败', e)
    //     }
    //   }

    // },
    open() {
      //跳转注册页面路由
      this.$router.push({ name: "supplierRegistration" });
    },
    async getDataDisplay() {

      let res = await dataDisplay()

      let { warningNumber, deliverGoods, goodsNumber, perCustomer, perCustomerPercent, sendTime, totalOrder, totalOrderPercent, totalSold, totalSoldPercent, perCustomerPercentIsup, totalOrderPercentIsup, totalSoldPercentIsup } = res.data
      // perCustomerPercent,
      // totalOrderPercent,
      //   totalSoldPercent

      this.form = {
        warningNumber,
        deliverGoods,
        goodsNumber,
        perCustomer,
        sendTime,
        totalOrder, totalSold,
        perCustomerPercentIsup: Number(perCustomerPercent) == 0 ? 0 : Number(perCustomerPercent) > 0 ? 1 : 2,//0为无样式，1为上升，2为下降
        totalOrderPercentIsup: Number(totalOrderPercent) == 0 ? 0 : Number(totalOrderPercent) > 0 ? 1 : 2,
        totalSoldPercentIsup: Number(totalSoldPercent) == 0 ? 0 : Number(totalSoldPercent) > 0 ? 1 : 2,
        totalOrderPercent: Math.abs(Number(totalOrderPercent)) != 0 ? Math.abs(totalOrderPercent) * 100 : '--',
        perCustomerPercent: Math.abs(Number(perCustomerPercent)) != 0 ? Math.abs(perCustomerPercent) * 100 : '--',
        totalSoldPercent: Math.abs(Number(totalSoldPercent)) != 0 ? Math.abs(totalSoldPercent) * 100 : '--',

      }
      console.log(this.form, '查看form')
    }
  }
}
</script>

<style lang="less" scoped>
.statistics-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;

  .inventory-warning-card {
    margin-bottom: 20px;

    .inventory-warning {
      display: flex;
      align-items: center;
      padding: 10px 0;

      .warning-label {
        color: #606266;
        font-size: 16px;
        margin-right: 15px;
      }

      .warning-count {
        font-size: 32px;
        font-weight: bold;
        margin-right: 15px;
      }

      .warning-icon {
        color: #E6A23C;
        font-size: 22px;
        margin-right: 8px;
      }

      .warning-text {
        color: #606266;
        font-size: 14px;
      }
    }
  }

  .stats-cards {
    margin-bottom: 30px;

    .stats-card {
      position: relative;
      height: 120px;

      .card-title {
        color: #909399;
        font-size: 14px;
        margin-bottom: 15px;
      }

      .card-content {
        .main-value {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 8px;
        }

        .trend {
          font-size: 12px;

          &.up {
            color: #67c23a;
          }

          &.down {
            color: #f56c6c;
          }
        }
      }

      .card-icon {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 48px;
        height: 48px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 24px;
          color: #fff;
        }

        &.blue {
          background-color: #409eff;
        }

        &.red {
          background-color: #f56c6c;
        }

        &.green {
          background-color: #67c23a;
        }

        &.purple {
          background-color: #8e44ad;
        }
      }
    }
  }

  .indicator-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .indicator-cards {
    .indicator-card {
      height: 120px;

      .indicator-name {
        color: #909399;
        font-size: 14px;
        margin-bottom: 10px;
      }

      .indicator-value {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .indicator-desc {
        font-size: 12px;
        color: #606266;

        &.up {
          color: #67c23a;
        }

        &.down {
          color: #f56c6c;
        }
      }
    }
  }
}

.white-bg {
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: 800;
}
</style>
